/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
// Icelandic
export default {
    'fabric.atlassianSwitcher.switchTo': 'Skipta í',
    'fabric.atlassianSwitcher.switchToTooltip': 'Skipta í…',
    'fabric.atlassianSwitcher.recent': 'Nýlegt',
    'fabric.atlassianSwitcher.more': 'Meira',
    'fabric.atlassianSwitcher.try': 'Prófa',
    'fabric.atlassianSwitcher.manageList': 'Vinna með lista',
    'fabric.atlassianSwitcher.jiraProject': 'Jira-verkefni',
    'fabric.atlassianSwitcher.confluenceSpace': 'Confluence-svæði',
    'fabric.atlassianSwitcher.people': 'Fólk',
    'fabric.atlassianSwitcher.administration': 'Stjórnun',
    'fabric.atlassianSwitcher.discoverMore': 'Uppgötva fleiri',
    'fabric.atlassianSwitcher.errorHeading': 'Eitthvað fór úrskeiðis',
    'fabric.atlassianSwitcher.errorText': 'Við fylgjumst með þessum villum en þér er velkomið að hafa samband við okkur ef þetta lagast ekki við endurnýjun.',
    'fabric.atlassianSwitcher.errorImageAltText': 'Bilað vélmenni og fjöldi aðila sem eru önnum kafnir við að laga það.',
    'fabric.atlassianSwitcher.expand': 'Stækka',
};
//# sourceMappingURL=is.js.map